const RECENT_SEARCHES = {
    TYPE: 'RECENT',
    LOCAL_STORAGE: 'recentSearches',
    MAX_TERMS: 6,
};

const SEARCH_PAGE_PATH = '/search/';

const SEARCH_QUERY_PARAM = 'q';
const ORIGINAL_SEARCH_QUERY_PARAM = 'oq';

const TRACKING = {
    CATEGORY: 'navigation',
    ACTION: 'header navigation click',
};

const KEY_UP_VALUE = 'up';
const KEY_DOWN_VALUE = 'down';

export {
    RECENT_SEARCHES,
    SEARCH_PAGE_PATH,
    SEARCH_QUERY_PARAM,
    TRACKING,
    KEY_UP_VALUE,
    KEY_DOWN_VALUE,
    ORIGINAL_SEARCH_QUERY_PARAM,
};
